export { default as SvgIcon } from 'helpers/SvgIcon/SvgIcon';
export type { SvgIconProps, SvgIconSize, IconTypes } from 'helpers/SvgIcon/SvgIcon';
